// src/pages/TokenPage.tsx
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MainLayout from '../components/MainLayout';
import TrackingMap from '../components/map';
import style from '../styles/Home.module.css';
import { useWhichDashboard } from '../hooks/useWhichDashboard';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const TokenPage = () => {
  const query = useQuery();
  const token = query.get('token');
  const dashData = useWhichDashboard();

  const [data, setData] = useState(null);
  const [checker, setChecker] = useState(true);
  const [allPolyline, setAllPolyline] = useState([]);
  const [tokenExpired, setTokenExpired] = useState(false);

  async function load(id) {
    try {
      const res = await fetch(`${dashData.api}api/v2/driverInfo/info?accessToken=${id}`);
      if (res.status === 401) {
        setTokenExpired(true);
        return;
      }
      const json = await res.json();
      setData(json);
      setChecker(false);
    } catch (error) {
      console.error(error);
      setTokenExpired(true);
    }
  }

  useMemo(() => {
    if (!(data && data.trackings?.length > 0) && token && checker) {
      load(token);
    }

    if (data?.trackings?.length > 0) {
      const poly = data.trackings.map(pol => [
        pol.coordinates.lat || 0,
        pol.coordinates.lng || 0,
      ]);
      setAllPolyline(poly);
    }
  }, [token, data, checker]);

  return data?.trackings?.length > 0 ? (
    <MainLayout
      name={data.company.name}
      driver={data.driver}
      trackings={data.trackings}
      company={data.company}
      load={() => token && load(token)}
    >
      <TrackingMap
        data={data}
        outerBounds={[allPolyline]}
        trackings={data.trackings}
      />
    </MainLayout>
  ) : (
    <main className={style.main}>
      <h1 className={style.title}>
        {tokenExpired ? 'Token Expired' : 'No Trackings'}
      </h1>
    </main>
  );
};

export default TokenPage;
